import * as xlsx from 'xlsx';
import {
  DELETE_BUBBLES,
  SAVE_BUBBLES,
  GET_BUBBLES,
} from '../store/bubbles/actions/actionTypes';

const EMPTY_VISUAL_MEASUREMENT_VALUE = {
  value: 'notCompleted',
  images: [],
  comment: '',
};

export default {
  methods: {
    formatValue(value) {
      if (value === undefined || value === '') return '0.0000';

      const num = parseFloat(value);
      if (isNaN(num)) return '0.0000';

      if (Number.isInteger(num)) {
        return num.toFixed(4);
      }

      return num.toFixed(4);
    },
    async exportDiagramData() {
      const workSheetBubbles = [];
      const header = {
        header: [
          'Label',
          'Bubble Type',
          'Description',
          'Unit',
          'Expected Value',
          'Tolerance 1',
          'Tolerance 2',
          'Positions',
          'Orientation',
        ],
      };

      const taskBubbles = await this.$store.dispatch(
        GET_BUBBLES,
        this.currentTask._id
      );
      const allowedTypes = [
        'runout',
        'diameter',
        'visual',
        'generic',
        'length',
      ];

      taskBubbles.sort((a, b) => a.number - b.number);
      taskBubbles.forEach((task) => {
        let bubbleType = task.type.toLowerCase();

        if (allowedTypes.includes(bubbleType)) {
          if (task.lengthType === 'aligned') {
            bubbleType = 'aligned length';
          }
          const row = {
            Label: task.number,
            'Bubble Type': bubbleType,
            Description: task.description,
            Unit: task.unit,
            'Expected Value': task.expectedValue,
            'Tolerance 1':
              task.type === 'runout' ? task.tolerance : task.positiveTolerance,
            'Tolerance 2': task.negativeTolerance,
            Positions:
              bubbleType === 'runout' && task.multipleMeasurements === false
                ? 1
                : task.measurementCount,
            Orientation: task.orientation,
          };
          workSheetBubbles.push(row);
        }
      });

      const workbook = xlsx.utils.book_new();
      const bubblesSheet = xlsx.utils.json_to_sheet(workSheetBubbles, header);
      xlsx.utils.book_append_sheet(workbook, bubblesSheet, 'Bubbles');

      const now = new Date();
      const datetimeString = `${now.getFullYear()}${now.getMonth()}${now.getDate()}${now.getHours()}${now.getMinutes()}`;
      const fileName = 'Diagram Bubbles List';

      xlsx.writeFile(
        workbook,
        `${fileName} - ${this.currentTask.title} - ${datetimeString}.xlsx`
      );
    },
    handleDiagramImportAdd(event) {
      const file = event.target.files[0];
      event.target.value = '';
      if (!file) {
        return;
      }
      const fileReader = new FileReader();
      fileReader.onload = (onloadEvent) => {
        const processFile = async () => {
          try {
            let result = await this.$store.dispatch(
              GET_BUBBLES,
              this.currentTask._id
            );
            if (!result) {
              result = [];
            }
            const importedBubbles = this.readDiagramFile(
              onloadEvent.target.result,
              result
            );
            if (!importedBubbles || importedBubbles.length === 0) {
              this.$buefy.dialog.confirm({
                title: 'Warning: Upload Diagram Labels',
                message:
                  'No Bubble found <br> all bubbles will get deleted.<br><br>Are you sure you want to proceed?',

                type: 'is-danger',
                hasIcon: true,
                icon: 'delete',
                confirmText: 'Upload',
                onConfirm: async () => {
                  this.isLoadingTask = true;
                  await this.$store.dispatch(
                    DELETE_BUBBLES,
                    this.currentTask._id
                  );
                  window.location.reload();
                },

                onCancel: () => {
                  this.isLoadingTask = false;
                },
              });
              return;
            }
            this.$buefy.dialog.confirm({
              title: 'Warning: Upload Diagram Labels',
              message:
                'Uploading new label/bubble data will <br>override all existing data, including all <br>measurements and images associated with <br>the existing labels/bubbles.<br><br>Are you sure you want to proceed?',

              type: 'is-danger',
              hasIcon: true,
              icon: 'delete',
              confirmText: 'Upload',
              onConfirm: async () => {
                this.isLoadingTask = true;
                await this.$store.dispatch(
                  DELETE_BUBBLES,
                  this.currentTask._id
                );

                const importedRows = [];
                importedBubbles.forEach((row) => {
                  importedRows.push(row);
                });
                await this.$store.dispatch(SAVE_BUBBLES, {
                  taskId: this.currentTask._id,
                  data: importedRows,
                });
                await this.$store.dispatch(GET_BUBBLES, this.currentTask._id);
                window.location.reload();
                this.isLoadingTask = false;
              },

              onCancel: () => {
                this.isLoadingTask = false;
              },
            });
          } catch (error) {
            console.error('Error during instruction import:', error);

            this.$buefy.snackbar.open({
              message:
                'An unexpected error occurred while importing the worksheet.',
              type: 'is-danger',
              position: 'is-top',
              duration: 5000,
              pauseOnHover: true,
            });
          }
          this.isLoadingTask = false;
        };
        processFile();
      };
      fileReader.readAsBinaryString(file);
    },

    readDiagramFile(binary, result) {
      const workbook = xlsx.read(binary, {
        type: 'binary',
      });

      const workSheetBubbles = xlsx.utils.sheet_to_json(
        workbook.Sheets[workbook.SheetNames[0]],
        {
          header: 1,
        }
      );

      const bubbleHeaders = workSheetBubbles[0].map((header) =>
        header.toLowerCase()
      );
      workSheetBubbles.splice(0, 1);
      workSheetBubbles.sort((a, b) => a[0] - b[0]);
      const diagramData = [];

      if (bubbleHeaders.length !== 0) {
        const labelLocation = bubbleHeaders.indexOf('label');
        const bubbleTypeLocation = bubbleHeaders.indexOf('bubble type');
        const descriptionLocation = bubbleHeaders.indexOf('description');
        const unitLocation = bubbleHeaders.indexOf('unit');
        const expectedValueLocation = bubbleHeaders.indexOf('expected value');
        const tolerance1Location = bubbleHeaders.indexOf('tolerance 1');
        const tolerance2Location = bubbleHeaders.indexOf('tolerance 2');
        const positionsLocation = bubbleHeaders.indexOf('positions');
        const orientationLocation = bubbleHeaders.indexOf('orientation');
        let validHeader = false;
        validHeader =
          labelLocation !== -1 &&
          bubbleTypeLocation !== -1 &&
          descriptionLocation !== -1 &&
          unitLocation !== -1 &&
          expectedValueLocation !== -1 &&
          tolerance1Location !== -1 &&
          tolerance2Location !== -1 &&
          positionsLocation !== -1 &&
          orientationLocation !== -1;

        if (!validHeader) {
          this.$buefy.toast.open({
            duration: 5000,
            message: this.$t('diagram_excel_import_failed'),
            type: 'is-danger',
          });

          this.isLoadingTask = false;
          return;
        }

        const allowedTypes = [
          'runout',
          'diameter',
          'visual',
          'generic',
          'length',
          'aligned length',
        ];
        workSheetBubbles.forEach((row) => {
          let match = result.find((item) => item.number === row[labelLocation]);
          if (!match) {
            match = [];
          }

          const bubbleType = (row[bubbleTypeLocation] || '').toLowerCase();
          let unitValue = '';
          let genericTol = false;

          const type =
            row[bubbleTypeLocation] === 'aligned length'
              ? 'length'
              : row[bubbleTypeLocation];
          if (match.type !== type && match.type === 'length') {
            match.firstPoint = { x: '', y: '' };
            match.secondPoint = { x: '', y: '' };
            match.thirdPoint = { x: '', y: '' };
            match.fourthPoint = { x: '', y: '' };
          } else if (match.type !== type && type === 'length') {
            match.firstPoint = match.point;
            match.secondPoint = match.point;
            match.thirdPoint = match.point;
            match.fourthPoint = match.point;
          }
          const emptyRow =
            !row[labelLocation] &&
            !row[bubbleTypeLocation] &&
            !row[descriptionLocation] &&
            !row[unitLocation] &&
            !row[expectedValueLocation] &&
            !row[tolerance1Location] &&
            !row[tolerance2Location] &&
            !row[positionsLocation] &&
            !row[orientationLocation];

          if (!emptyRow && allowedTypes.includes(bubbleType)) {
            let expectedValueLoc = row[expectedValueLocation];
            let tolerance1Loc = row[tolerance1Location];
            let tolerance2Loc = row[tolerance2Location];
            if (
              row[bubbleTypeLocation] === 'generic' &&
              (row[expectedValueLocation] >= 0.0 ||
                row[tolerance1Location] >= 0.0 ||
                row[tolerance2Location] >= 0.0)
            ) {
              expectedValueLoc = this.formatValue(row[expectedValueLocation]);
              tolerance1Loc = this.formatValue(row[tolerance1Location]);
              tolerance2Loc = this.formatValue(row[tolerance2Location]);
              genericTol = true;
            } else if (
              row[bubbleTypeLocation] === 'runout' &&
              (row[tolerance1Location] === undefined ||
                row[tolerance1Location] === '')
            ) {
              tolerance1Loc = '0.0000';
            } else if (
              row[bubbleTypeLocation] === 'diameter' ||
              row[bubbleTypeLocation] === 'length' ||
              row[bubbleTypeLocation] === 'aligned length'
            ) {
              expectedValueLoc = this.formatValue(row[expectedValueLocation]);
              tolerance1Loc = this.formatValue(row[tolerance1Location]);
              tolerance2Loc = this.formatValue(row[tolerance2Location]);
            }
            if (row[bubbleTypeLocation] === 'visual') {
              unitValue = '';
            } else if (
              (row[unitLocation] === 'in' ||
                row[unitLocation] === 'inch' ||
                row[unitLocation] === undefined) &&
              row[bubbleTypeLocation] !== 'visual'
            ) {
              unitValue = 'in';
            } else {
              unitValue = row[unitLocation];
            }

            const diagram = {
              number: row[labelLocation],
              type:
                row[bubbleTypeLocation] === 'aligned length'
                  ? 'length'
                  : row[bubbleTypeLocation],
              lengthType:
                row[bubbleTypeLocation] === 'aligned length' ? 'aligned' : '',
              description: row[descriptionLocation] || '',
              unit: unitValue,
              expectedValue: expectedValueLoc || '',
              toleranceType: 'normal',
              tolerance:
                row[bubbleTypeLocation] === 'runout' ? tolerance1Loc : '',
              positiveTolerance:
                row[bubbleTypeLocation] !== 'runout' ? tolerance1Loc : '',
              negativeTolerance: tolerance2Loc || '',
              genericTolerance: genericTol,
              measurementCount:
                row[bubbleTypeLocation] === 'visual'
                  ? 1
                  : row[positionsLocation] || 1,
              measurements:
                row[bubbleTypeLocation] === 'visual'
                  ? [
                      EMPTY_VISUAL_MEASUREMENT_VALUE,
                      EMPTY_VISUAL_MEASUREMENT_VALUE,
                      EMPTY_VISUAL_MEASUREMENT_VALUE,
                      EMPTY_VISUAL_MEASUREMENT_VALUE,
                    ]
                  : [],
              multipleMeasurements:
                row[positionsLocation] > 1 &&
                row[bubbleTypeLocation] !== 'visual',
              orientation: row[orientationLocation] || 'up',
              hasDescription: !!row[descriptionLocation],
              descriptionDropdown: match.descriptionDropdown
                ? match.descriptionDropdown
                : 'other',
              point: match.point ? match.point : { x: '', y: '' },
              firstPoint: match.firstPoint
                ? match.firstPoint
                : { x: '', y: '' },
              secondPoint: match.secondPoint
                ? match.secondPoint
                : { x: '', y: '' },
              thirdPoint: match.thirdPoint
                ? match.thirdPoint
                : { x: '', y: '' },
              fourthPoint: match.fourthPoint
                ? match.fourthPoint
                : { x: '', y: '' },
            };
            diagramData.push(diagram);
          }
        });
        return diagramData;
      }
    },
  },
};
